import { Injectable } from '@angular/core';

const STORAGE_KEY = 'currentUser';

@Injectable({
  providedIn: 'root',
})
export class UserService {

  getCurrentUser(): any | null {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }

  get accessToken(): string | null {
    return this.getCurrentUser()?.access_token ?? null;
  }

  get refreshToken(): string | null {
    return this.getCurrentUser()?.refresh_token ?? null;
  }

  get user(): any | null {
    return this.getCurrentUser()?.user ?? null;
  }

  get userType(): number | null {
    return this.user?.profile?.user_type ?? null;
  }

  get userId(): number | null {
    return this.user?.pk ?? null;
  }

  get userGroups(): any[] {
    return this.user?.groups ?? [];
  }

  get userName(): string {
    const u = this.user;
    if (!u) return '';
    return `${u.first_name ?? ''} ${u.last_name ?? ''}`.trim();
  }

  get avatar(): string {
    return this.user?.profile?.avatar || 'assets/images/avatar.svg';
  }

  isAuthenticated(): boolean {
    return localStorage.getItem(STORAGE_KEY) !== null && localStorage.getItem(STORAGE_KEY) != '';
  }

  hasRole(expectedRoles: number[]): boolean {
    const type = this.userType;
    return type !== null && expectedRoles.includes(type);
  }

  setCurrentUser(data: any): void {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  }

  updateAccessToken(newToken: string): void {
    const current = this.getCurrentUser();
    if (current) {
      current.access_token = newToken;
      this.setCurrentUser(current);
    }
  }

  clearCurrentUser(): void {
    localStorage.removeItem(STORAGE_KEY);
  }

  clearAll(): void {
    localStorage.clear();
  }
}
